import React from 'react';
import { MuiTelInput, MuiTelInputProps } from 'mui-tel-input';
import { Box, styled } from '@mui/material';
import { TypographyContainer } from './InputText';
import { SMRegular, TEXT_SIZE } from '@/typography/Typography';

// An intersection rather than `interface extends`: MuiTelInputProps contains a
// discriminated union on forceCallingCode, and an interface cannot extend one.
type MobileInputProps = MuiTelInputProps & {
    label?: string;
    error?: boolean;
    helperText?: string | any;
    required?: boolean;
};

const MuiTelInputStyled = styled(MuiTelInput)`
    & .MuiOutlinedInput-root {
        border-radius: 8px;
        border: 1px solid #d0d5dd;
        height: 36.7px;
    }

    & .MuiOutlinedInput-root {
        border: none;
    }

    & input {
        height: 36.7px;
        padding: 0 0px;
    }

    & .MuiTelInput-IconButton {
        padding: 0px;
    }

    /* The flag is a bare <img>: there is no <picture> wrapper to nest under. */
    & .MuiTelInput-FlagImg {
        border-radius: 4px;
        height: 20.25px;
        width: 27px;
    }
`;

const MobileInput: React.FC<MobileInputProps> = ({
    label,
    error,
    helperText,
    required,
    ...props
}) => {
    return (
        <Box display={'flex'} flexDirection={'column'}>
            {label && (
                <TypographyContainer
                    fontWeight={500}
                    fontSize={TEXT_SIZE.MEDIUM_SMALL}
                    data-text={required ? '*' : ''}
                >
                    {label}
                </TypographyContainer>
            )}
            <MuiTelInputStyled slotProps={{}} {...props} error={error} />
            {helperText && (
                <SMRegular
                    mt={0.5}
                    variant="caption"
                    color={error ? 'error' : 'textSecondary'}
                >
                    {helperText}
                </SMRegular>
            )}
        </Box>
    );
};

export default MobileInput;
